import React from 'react';
import { InputAdornment, TextField, withStyles } from '@material-ui/core';
import styled from 'styled-components';

const StyledIcon = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0;
  margin-left: 6px;
`;

const classes = {
  root: {
    fontWeight: 500,
    color: '#000',
  },
  input: {
    padding: '12px 6px !important',
    borderBottom: 'none',
    background: '#f5f5f5'
  },
  underline: {
    '&:before': {
      borderBottom: 'none !important'
    },
    '&:after': {
      borderBottom: 'none !important'
    }
  },
  adornedStart: {
    background: '#f5f5f5'
  }
};

const getStyleProps = (variant, classes, Icon = null) => {
  if (variant === 'filled') {
    return {
      InputLabelProps: {
        shrink: true
      },
      InputProps: {
        startAdornment: Icon ? (
          <InputAdornment position="start">
            <StyledIcon><Icon /></StyledIcon>
          </InputAdornment>
        ): null,
        classes: {
          adornedStart: classes.adornedStart,
          root: classes.root,
          input: classes.input,
          underline: classes.underline
        }
      },
      classes: {
        root: classes.root
      }
    };
  }

  return {};
};

const FormTextField = ({
  input,
  label = '',
  meta: { touched, error, invalid },
  customError,
  classes,
  styleVariant,
  Icon,
  ...custom
}) => {
  const styleProps = getStyleProps(styleVariant, classes, Icon);
  return (
    <TextField
      error={(touched && invalid) || !!customError}
      placeholder={label}
      label={label}
      helperText={(touched && invalid && error) || customError}
      {...styleProps}
      {...input}
      {...custom}
    />
  );
};

export default withStyles(classes)(FormTextField);
